import { z } from "zod";
/**
 * Kontrakt klient–serwer. Jedno źródło prawdy dla obu stron: zmiana eventu
 * powoduje błąd kompilacji tam, gdzie nie została uwzględniona.
 *
 * Każde wejście od klienta przechodzi przez `zod` — telefon jest niezaufany,
 * a stan gry jest zbyt cenny, żeby wpuszczać do niego cokolwiek bez walidacji.
 */
/**
 * Podbijana przy każdej niezgodnej zmianie kształtu eventów.
 *
 * Klient wysyła swoją wersję w handshake'u; przy niezgodności serwer odsyła
 * `protocol:outdated` i klient każe użytkownikowi odświeżyć. Bez tego telefon
 * z zakeszowanym service workerem po deployu wygląda na zepsuty tylko u jednej
 * osoby, co jest najgorszym rodzajem błędu do zdiagnozowania w aucie.
 */
export const PROTOCOL_VERSION = 1;
// ---------------------------------------------------------------------------
// Klient → serwer
// ---------------------------------------------------------------------------
export const handshakeSchema = z.object({
    protocolVersion: z.number().int(),
});
export const createGameSchema = z.object({
    gameType: z.string().min(1).max(64),
    settings: z.unknown(),
    /** Zaproszeni z listy kont. Host dopisywany automatycznie. */
    invitedUserIds: z.array(z.string()).max(16).default([]),
    /** Dodatkowo wygenerować kod pokoju — dla gościa, który nie jest na liście. */
    withCode: z.boolean().default(false),
});
export const joinGameSchema = z.object({
    gameId: z.string().min(1),
});
export const joinByCodeSchema = z.object({
    code: z.string().min(4).max(8),
});
export const leaveGameSchema = z.object({
    gameId: z.string().min(1),
});
/** Host kasuje partię, która nigdy się nie skończy. */
export const abandonGameSchema = z.object({
    gameId: z.string().min(1),
});
export const gameActionSchema = z.object({
    gameId: z.string().min(1),
    action: z.unknown(),
});
export function ackOk(data) {
    return { ok: true, data };
}
export function ackError(error) {
    return { ok: false, error };
}
//# sourceMappingURL=protocol.js.map